import Empty from 'constants/empty';

export default function getResource(label, vars = Empty.Array) {
    const resources = {
        orders: 'Historique des achats',
        noOrders: 'Vous n’avez pas de commande récente.',
        orderDate: 'Date de la commande',
        pickupOrder: 'Commande à ramasser',
        sameDayOrder: 'Livraison le jour même',
        fastDelivery: 'Livraison rapide',
        standardOrder: 'Commande standard',
        orderNumber: 'Numéro de commande',
        orderType: 'Type de commande',
        status: 'Statut',
        details: 'Détails',
        viewDetails: 'Voir les détails',
        showMore: 'Afficher plus',
        viewAllPurchases: 'Voir tous les achats',
        replenItemsCarouselTitle: 'Réapprovisionner les achats antérieurs',
        replenItemsViewAll: 'Voir tout',
        seeAllItems: (count) => `Voir tous les ${count} articles`,
        orderContains: 'Cette commande contient',
        product: 'essentiel',
        products: 'essentiels',
        and: 'et',
        more: 'voir plus',
        productFallback: 'Essentiel',
        viewAll: 'Tout afficher'
    };

    return resources[label];
}
